import React, { createContext, FC, useContext, useEffect, useState } from "react"
import { OrgGHGroup } from "../../../../api/types/Group";

type THierarchyLevelOnDisplay = {
  group_id: string | null;
  level: number;
  groups: OrgGHGroup[];
  selectedGroup: string | null;
  lastPage?: number;
}

type TGHContext = {
  hierarchyOnDisplay: THierarchyLevelOnDisplay[];
  setHierarchyOnDisplay: (value: THierarchyLevelOnDisplay[]) => void;
  movingGroup: string | boolean;
  setMovingGroup: (value: string | boolean) => void;
  parentOfMovingGroup: string | null;
  setParentOfMovingGroup: (value: string | null) => void;
  moveToGroup: string | null;
  setMoveToGroup: (value: string | null) => void;
}

const contextDefaultValue: TGHContext = {
  hierarchyOnDisplay: [],
  setHierarchyOnDisplay: (value) => { },
  movingGroup: false,
  setMovingGroup: (value) => { },
  parentOfMovingGroup: null,
  setParentOfMovingGroup: (value) => { },
  moveToGroup: null,
  setMoveToGroup: (value) => { },
}

const ghContext = createContext(contextDefaultValue)

export const GHContextProvider: FC<{ children: React.ReactNode }> = ({ children }) => {

  const [hierarchyOnDisplay, setHierarchyOnDisplay] = useState<THierarchyLevelOnDisplay[]>([]);
  const [movingGroup, setMovingGroup] = useState<string | boolean>(false);
  const [parentOfMovingGroup, setParentOfMovingGroup] = useState<string | null>(null);
  const [moveToGroup, setMoveToGroup] = useState<string | null>(null);

  return (
    <ghContext.Provider
      value={{
        hierarchyOnDisplay,
        setHierarchyOnDisplay,
        movingGroup,
        setMovingGroup,
        parentOfMovingGroup,
        setParentOfMovingGroup,
        moveToGroup,
        setMoveToGroup,
      }}
    >
      {children}
    </ghContext.Provider>
  )
}

export const useGHContext = () => {
  const {
    hierarchyOnDisplay,
    setHierarchyOnDisplay,
    movingGroup,
    setMovingGroup,
    parentOfMovingGroup,
    setParentOfMovingGroup,
    moveToGroup,
    setMoveToGroup,
  } = useContext(ghContext)
  return {
    hierarchyOnDisplay,
    setHierarchyOnDisplay,
    movingGroup,
    setMovingGroup,
    parentOfMovingGroup,
    setParentOfMovingGroup,
    moveToGroup,
    setMoveToGroup,
  }
}
